import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Colors } from 'utils';
import { Table, Pagination, Input, Modal, PaperClip } from 'components';
import {
  CleanIcon,
  ViewIcon,
  Menu as MenuIcons,
  AddIcon,
  DownloadIcon,
  UploadIcon,
  WarningIcon,
} from 'assets/icons';
import { GeneralService, SignatureService, StorageService } from 'services';
import moment from 'moment';
import ModalCreate from './modal-create';
import { TYPES } from '../home/home';
import ModalRating from '../home/modal-rating';
import { WhiteImage } from 'assets/img';
import ModalPayment from 'components/modal-payment';
import { useApacuana } from 'contexts/ApacuanaContext';
import { PDFDocument } from 'pdf-lib';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const TABS = {
  MINE: 'mine',
  PENDING: 'pending',
};

const INITIAL_STATE = {
  search: '',
  status: '',
};

class Signature extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: ['', '', ''],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    item: null,
    visible: false,
    visible_modal: false,
    visible_payment: false,
    visible_consumed: false,
    plan_user: undefined,
    membership_status: Constants.ACCES_STATUS.ACCESS_DENIED,
    price: 0,
    active_tab: TABS.MINE,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: { title: 'Firma Electrónica', onBack: null },
    });
    this.props.dispatch({ type: 'SET_SUBHEADER', payload: { title: '' } });
    this.load();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await SignatureService.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      user_id: this.props.user?.id,
    });
    const selects: any = await GeneralService.getSelects({
      user_id: this.props.user?.id,
      services: true,
      service_id: Constants.SERVICES.SIGN,
    });
    this.setState({
      data: res.signatures.rows,
      last_page: res.signatures.count,
      plan_user: res.plan_user,
      membership_status: res.membership_status,
      price: selects.services[0].price,
    });
  };

  reset = () => {
    this.setState({ form: INITIAL_STATE, page: 1 }, () => this.load(true));
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: { ...this.state.form, [e.target.name]: e.target.value },
      },
      callback,
    );
  };

  add = () => {
    const { membership_status } = this.state;
    if (membership_status === Constants.ACCES_STATUS.ACCESS_GRANTED)
      return this.setState({ visible: true });
    if (membership_status === Constants.ACCES_STATUS.ACCESS_LIMITED)
      return this.setState({ visible_consumed: true });
  };

  openModalPayment = () => {
    this.setState({ visible_payment: true, visible_consumed: false });
  };

  onClose = () => {
    this.setState(
      {
        visible: false,
        visible_modal: false,
        visible_payment: false,
        visible_consumed: false,
      },
      () => this.load(true),
    );
  };

  getColor = (item: any) => {
    switch (item.status) {
      case Constants.REVISION_STATUS.PENDING:
        return Colors.orange;
      case Constants.REVISION_STATUS.ACCEPTED:
        return Colors.green;
      case Constants.REVISION_STATUS.REJECTED:
        return Colors.danger;
    }
  };

  sendResponse = async (item: any, file: any) => {
    await SignatureService.saveResponse({
      file,
      signature_id: item.id,
      hasFile: true,
    });
    Globals.showSuccess('Se ha enviado el archivo correctamente');
    this.load(true);
  };

  setApproved = (item: any, response: number) => {
    switch (response) {
      case Constants.SIGNATURE_STATUS.ACCEPTED:
        Globals.confirm('¿Desea aprobar el archivo?', async () => {
          await SignatureService.changeStatus({
            signature_id: item.id,
            status: Constants.SIGNATURE_STATUS.ACCEPTED,
          });
          this.setState({ item, visible_modal: true });
          this.load(true);
        });
        break;
      case Constants.SIGNATURE_STATUS.REJECTED:
        Globals.confirm('¿Desea rechazar el archivo?', async () => {
          await SignatureService.changeStatus({
            signature_id: item.id,
            status: Constants.SIGNATURE_STATUS.REJECTED,
          });
          this.load(true);
        });
        break;
    }
  };

  onCloseRating = () => {
    this.setState({ visible_modal: false, type: null } as any);
  };

  onSuccesPayment = async (data: any) => {
    try {
      const { user } = this.props;
      await GeneralService.savePayment({
        user_id: user?.id,
        service_id: Constants.SERVICES.SIGN,
        payment_method_id: data?.payment_method_id,
        ...data,
      });
      Globals.showSuccess('Se ha enviado el pago correctamente, ya puede realizar una llamada');
      this.onClose();
    } catch (error) {}
  };

  openFile = async (key: string) => {
    const opened = await StorageService.openFile(key);
    if (!opened) Globals.showError('No se pudo obtener el archivo');
  };

  render() {
    const { visible, visible_modal, visible_payment, visible_consumed, active_tab } = this.state;
    const is_client = this.props.user?.level_id == Constants.LEVELS.CLIENT;
    const plan_user: any = this.state.plan_user;

    return (
      <div id='client-signature'>
        <div className='row row-tabs'>
          <div className='col-md-4' style={{ padding: '8px' }}>
            <button
              className={`btn ${active_tab == TABS.MINE ? 'active' : 'inactive'}`}
              onClick={() => this.setState({ active_tab: TABS.MINE })}
            >
              Mis firmas
            </button>
          </div>
          <div className='col-md-4' style={{ padding: '8px' }}>
            <button
              className={`btn ${active_tab == TABS.PENDING ? 'active' : 'inactive'}`}
              onClick={() => this.setState({ active_tab: TABS.PENDING })}
            >
              Solicitudes de firma
            </button>
          </div>
        </div>

        <Modal
          className='modal-create-signature'
          visible={visible}
          title=''
          onClose={() => this.onClose()}
        >
          {/* @ts-ignore */}
          <ModalCreate item={this.state.item} onClose={() => this.onClose()} />
        </Modal>

        <Modal
          className='modal-rating'
          visible={visible_modal}
          title='Calificar'
          onClose={() => this.onCloseRating()}
        >
          {/* @ts-ignore */}
          <ModalRating
            item={this.state.item}
            type={TYPES.SIGNATURE}
            onClose={() => this.onCloseRating()}
          />
        </Modal>

        <Modal
          id='modal-consumed-payment'
          visible={visible_consumed}
          title='Llamada telefónica'
          onClose={() => this.onClose()}
        >
          <img src={WarningIcon} />
          <p className='title'>Usted ha consumido el registro de firmas electrónicas</p>
          <p>Puede obtener el servicio mediante pago o esperar el próximo mes</p>
          <div className='btn-container'>
            <button className='btn btn-accept' onClick={this.openModalPayment}>
              Pagar
            </button>
            <button className='btn' onClick={() => this.onClose()}>
              Cancelar
            </button>
          </div>
        </Modal>

        <Modal
          className='modal-add-payement'
          visible={visible_payment}
          title=''
          onClose={() => this.onClose()}
        >
          {/* @ts-ignore */}
          <ModalPayment
            onClose={(reload: boolean) => this.onClose()}
            price={this.state.price}
            onSuccess={(data: any) => this.onSuccesPayment(data)}
            title='Firma electrónica'
          />
        </Modal>

        {active_tab === TABS.PENDING ? (
          <PendingSignatures user={this.props.user} />
        ) : plan_user === null ? (
          <div className='container-no-membership'>
            <p>Para continuar debe tener una membresía activa</p>
          </div>
        ) : (
          <>
            <div className='row row-filter'>
              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-md-4'>
                    <Input
                      value={this.state.form.search}
                      name='search'
                      label='Buscar'
                      placeholder='Buscar'
                      className='input-table'
                      onSubmit={() => this.load()}
                      onChange={(e: any) => {
                        clearTimeout(this.timer);
                        this.timer = setTimeout(() => this.load(true), 1000);
                        this.change(e);
                      }}
                    />
                  </div>
                  <div className='col-md-4'>
                    {this.state.form != INITIAL_STATE && (
                      <button className='btn btn-clean' onClick={() => this.reset()}>
                        <img src={CleanIcon} />
                      </button>
                    )}
                  </div>
                  {this.state.membership_status !== Constants.ACCES_STATUS.ACCESS_DENIED && (
                    <div className='col-md-4 text-right'>
                      <button className='container-add-table' onClick={() => this.add()}>
                        <img src={AddIcon} />
                        <p>Nuevo</p>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <Table title='' data={this.state.data.length} header={this.state.header}>
              {this.state.data.map((i: any, index: number) => {
                return (
                  <tr key={index}>
                    <td style={{ width: '40%' }}>
                      <div className='container-date'>
                        <div className='date'>
                          <p>{moment(i.created_at).format('DD/MM/YYYY')}</p>
                        </div>
                        <div className='code'>
                          <p>ID {i.number}</p>
                        </div>
                      </div>
                      <p className='text-secondary' style={{ fontSize: 13, margin: 0 }}>
                        <strong>Participantes: </strong>
                        {(() => {
                          const all = [i.user, ...(i.signers || []).map((s: any) => s.user)];
                          const seen = new Set<number>();
                          const participants = all.filter((u: any) => {
                            if (!u || seen.has(u.id)) return false;
                            seen.add(u.id);
                            return true;
                          });
                          return participants.length
                            ? participants
                                .map((p: any) => `${p.name || ''} ${p.lastname || ''}`.trim())
                                .join(', ')
                            : 'Sin otros participantes';
                        })()}
                      </p>
                    </td>
                    <td style={{ width: '25%', textAlign: 'center' }}>
                      <div
                        className='container-status'
                        style={{ backgroundColor: this.getColor(i) }}
                      >
                        <p>{i.status_text}</p>
                      </div>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <div className='container-files'>
                        <div>
                          <button
                            type='button'
                            className={`file ${i.file == null ? 'disabled' : ''}`}
                            disabled={!i.file}
                            onClick={() => i.file && this.openFile(i.file)}
                          >
                            <img src={!is_client ? DownloadIcon : ViewIcon} />
                            <div style={{ flex: 1 }}>
                              <p>{!is_client ? 'Descargar documento' : 'Documento enviado'}</p>
                            </div>
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </Table>

            <Pagination
              pages={this.state.last_page}
              active={this.state.page}
              onChange={async (page: number) => {
                await this.setState({ page });
                this.load();
              }}
            />
          </>
        )}
      </div>
    );
  }
}

// ── Pestaña "Solicitudes pendientes de firma" (feature invitar firmantes, LT-305) ──
// Reutiliza el mismo mecanismo de Apacuana que ya usa el modal de creación
// (addSigner + getDocsByCustomer + signDocument sobre el certificado ya
// existente en el dispositivo) para firmar el documento del solicitante,
// y reporta el resultado al backend con reportSigned.
const base64ToFile = (base64Data: string, filename: string, mimeType: string): File => {
  const base64Content = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data;
  const byteCharacters = atob(base64Content);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new File([new Blob([byteArray], { type: mimeType })], filename, { type: mimeType });
};

const PendingSignatures = ({ user }: { user: any }) => {
  const apacuanaContext: any = useApacuana();
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState<any[]>([]);
  const [signingItem, setSigningItem] = useState<any>(null);
  const [password, setPassword] = useState('');

  const load = async () => {
    try {
      const res: any = await SignatureService.getPendingRequests({
        user_id: user?.id,
        withoutLoading: true,
      });
      setRequests(res.requests || []);
    } catch (error) {
      console.error('Error al cargar solicitudes pendientes de firma:', error);
    }
  };

  // Descarga el documento original (subido por el solicitante) como File,
  // igual que lo hace la vista de admin para poder re-adjuntarlo a Apacuana.
  const getDocumentFile = async (signature: any) => {
    const url = Constants.BASE_STORAGE + signature.file;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('No se pudo descargar el documento a firmar.');
    }
    const blob = await response.blob();
    const mimeType = response.headers.get('Content-Type') || 'application/pdf';
    const fileName = (signature.file || 'documento.pdf').split('/').pop();
    return new File([blob], fileName, { type: mimeType });
  };

  const sign = async () => {
    if (!signingItem) return;
    if (password.length < 8) {
      Globals.showError('Debe ingresar su contraseña de certificado electrónico.');
      return;
    }

    setLoading(true);
    try {
      const originalFile = await getDocumentFile(signingItem.signature);

      // --- Añadir hoja en blanco al PDF, mismo procedimiento que modal-create ---
      const existingPdfBytes = await originalFile.arrayBuffer();
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      pdfDoc.addPage();
      const pageCount = pdfDoc.getPageCount();
      const modifiedPdfBytes: any = await pdfDoc.save();
      const modifiedFile = new File([new Blob([modifiedPdfBytes])], originalFile.name, {
        type: 'application/pdf',
      });

      const fullDocument = apacuanaContext?.user?.full_document ?? '';
      const [typedoc, doc] = fullDocument.split('-');
      if (!typedoc || !doc) {
        Globals.showError('No se pudo leer su documento de identidad. Por favor contacte soporte.');
        return;
      }

      const signerData = {
        name: modifiedFile.name,
        reference: '',
        typedoc,
        doc,
        signature: [{ page: pageCount, x: 0.2, y: 0.7 }],
        file: modifiedFile,
      };

      await apacuanaContext?.sdk?.addSigner(signerData);

      const docToSignRes: any = await apacuanaContext?.sdk?.getDocsByCustomer({ page: 0, size: 1 });
      const preparedDoc = docToSignRes?.data?.records?.[0];
      if (!preparedDoc) {
        throw new Error('No se encontró el documento preparado para firmar.');
      }

      const signDoc: any = await apacuanaContext?.sdk?.signDocument({
        pin: password,
        signature: {
          id: preparedDoc.signaturedata.id,
          positions: preparedDoc.signaturedata.positions,
        },
        document: modifiedFile,
      });

      if (!signDoc || !signDoc.data?.result) {
        throw new Error('Credenciales incorrectas o error en el servidor de firma.');
      }

      // NOTA: se asume que `signaturedata.id` es el "docId" que Apacuana usa como
      // referencia del documento firmado (mismo id que ya se usa como
      // `signature.id` al llamar signDocument). Falta verificar contra la
      // respuesta real del SDK que este sea el campo correcto para
      // `apacuana_reference` antes de dar el flujo por cerrado.
      await SignatureService.reportSigned({
        signature_signer_id: signingItem.id,
        apacuana_reference: String(preparedDoc.signaturedata.id),
      });

      Globals.showSuccess('Ha firmado el documento correctamente.');
      setSigningItem(null);
      setPassword('');
      load();
    } catch (error: any) {
      console.error('Error al firmar documento:', error);
      Globals.showError(error.message || 'Error al firmar el documento.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (loading) {
      Globals.setLoading();
    } else {
      Globals.quitLoading();
    }
  }, [loading]);

  useEffect(() => {
    load();
  }, []);

  // Todos los involucrados en el documento (dueño + resto de los invitados),
  // excluyendo siempre a quien está viendo la tarjeta.
  const getParticipants = (req: any) => {
    const all = [req.signature?.user, ...(req.signature?.signers || []).map((s: any) => s.user)];
    const seen = new Set<number>();
    return all.filter((u: any) => {
      if (!u || u.id === user?.id || seen.has(u.id)) return false;
      seen.add(u.id);
      return true;
    });
  };

  return (
    <>
      <Table title='' data={requests.length} header={['', '', '']}>
        {requests.map((req: any) => {
          const participants = getParticipants(req);
          const isSigned = req.status === Constants.SIGNATURE_SIGNER_STATUS.SIGNED;
          return (
            <tr key={req.id}>
              <td style={{ width: '50%' }}>
                <div className='container-date'>
                  <div className='date'>
                    <p>{moment(req.signature?.created_at).format('DD/MM/YYYY')}</p>
                  </div>
                  <div className='code'>
                    <p>ID {req.signature?.number}</p>
                  </div>
                </div>
                <div className='container-lawyer'>
                  <img
                    src={
                      req.inviter?.photo ? Constants.BASE_STORAGE + req.inviter.photo : WhiteImage
                    }
                  />
                  <div className='container-name'>
                    <p>
                      <span className='bold'>
                        {req.inviter ? `${req.inviter.name} ${req.inviter.lastname}` : 'Un usuario'}
                      </span>{' '}
                      te invitó a firmar
                    </p>
                  </div>
                </div>
                <p className='text-secondary' style={{ fontSize: 13, margin: 0 }}>
                  <strong>Participantes: </strong>
                  {participants.length
                    ? participants
                        .map((p: any) => `${p.name || ''} ${p.lastname || ''}`.trim())
                        .join(', ')
                    : 'Sin otros participantes'}
                </p>
              </td>
              <td style={{ textAlign: 'center' }}>
                <div
                  className='container-status'
                  style={{ backgroundColor: isSigned ? Colors.green : Colors.orange, width: 150 }}
                >
                  <p>{isSigned ? 'Firmado' : 'Pendiente de firma'}</p>
                </div>
              </td>
              <td style={{ textAlign: 'center' }}>
                <div className='container-files' style={{ flexWrap: 'nowrap' }}>
                  <button
                    type='button'
                    className={`file ${!req.signature?.file ? 'disabled' : ''}`}
                    disabled={!req.signature?.file}
                    style={{ margin: 0 }}
                    onClick={() =>
                      req.signature?.file && StorageService.openFile(req.signature.file)
                    }
                  >
                    <img src={ViewIcon} />
                    <div style={{ flex: 1 }}>
                      <p>Ver documento</p>
                    </div>
                  </button>
                </div>
              </td>
              <td style={{ textAlign: 'center' }}>
                <div className='container-files' style={{ flexWrap: 'nowrap' }}>
                  {isSigned ? (
                    <p style={{ margin: 0, padding: 0 }}>Firmado ✓</p>
                  ) : (
                    <button
                      type='button'
                      className='container-add-table'
                      style={{
                        margin: 0,
                        padding: '0 10px',
                        height: '26.33px',
                        boxSizing: 'border-box',
                      }}
                      onClick={() => setSigningItem(req)}
                    >
                      <p style={{ margin: 0, padding: 0 }}>Firmar</p>
                    </button>
                  )}
                </div>
              </td>
            </tr>
          );
        })}
      </Table>

      {signingItem && (
        <div
          className='modal fade show'
          tabIndex={-1}
          role='dialog'
          style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <div className='modal-dialog modal-dialog-centered' role='document'>
            <div className='modal-content'>
              <div className='modal-header' style={{ background: '#fff' }}>
                <h5 className='modal-title'>Clave de certificado electrónico</h5>
                <span
                  className='btn-close'
                  onClick={() => {
                    setSigningItem(null);
                    setPassword('');
                  }}
                  aria-label='Close'
                  style={{ fontWeight: 700, cursor: 'pointer' }}
                >
                  X
                </span>
              </div>
              <div className='modal-body' style={{ background: '#fff' }}>
                <div className='container-fluid'>
                  <p className='text-secondary' style={{ fontSize: '1rem' }}>
                    Debe ingresar la contraseña con la cual generó su certificado para proceder a
                    firmar
                  </p>
                  <Input
                    maxLength={12}
                    type='password'
                    color='white'
                    name='password'
                    label='Contraseña'
                    value={password}
                    onChange={(e: any) => setPassword(e.target.value)}
                  />
                  <button
                    style={{ width: '100%', backgroundColor: '#0777FF !important', color: '#fff' }}
                    type='button'
                    disabled={password.length < 8}
                    className='btn btn-report active'
                    onClick={sign}
                  >
                    Continuar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default connect((state: RootState) => {
  return { user: state.user };
})(Signature);
